import { Accordion, AccordionDetails, Typography } from '@mui/material';
import { memo, useState, useCallback } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { Check, Close, ExpandMore } from '@mui/icons-material';
import { useFormikContext } from 'formik';
import { FormikErrors, FormikTouched } from 'formik';
import { AccordionEditDataControlPerson as AccordionEditControlDataVM } from 'shell/view-models/edit-data-control-person';
import FormEditControlData from 'shell/components/shared/edit-data/form';
import { CancelMarriageFormVM } from 'mutation/view-models/cancel-marriage';

const EditDataComponent = (): React.ReactElement => {
  const [open, setOpen] = useState(true);

  const formContext = useFormikContext<CancelMarriageFormVM>();

  const onFieldEditDataChange = useCallback(
    (key, value) => {
      formContext.setFieldValue('editDataControl', {
        ...formContext.values.editDataControl,
        [key]: value,
      });
    },
    [formContext.values.editDataControl, formContext.setFieldValue]
  );

  return (
    <Accordion
      expanded={open}
      onChange={() => {
        setOpen(!open);
      }}
    >
      <AccordionSummary
        aria-controls="panel-person-edit-data-control-content"
        id="panel-person-edit-data-control-header"
        expandIcon={<ExpandMore />}
      >
        {formContext.errors.editDataControl ? <Close color="error" /> : <Check color="success" />}
        <Typography>Dati di controllo modifica</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <FormEditControlData
          values={formContext.values.editDataControl}
          onChange={onFieldEditDataChange}
          isEditMode
          fieldsDisabled={{
            flag: true,
            mutationReason: true,
          }}
          errors={formContext.errors.editDataControl as FormikErrors<AccordionEditControlDataVM>}
          touched={
            formContext.touched
              .editDataControl as unknown as FormikTouched<AccordionEditControlDataVM>
          }
        />
      </AccordionDetails>
    </Accordion>
  );
};

EditDataComponent.displayName = 'Accordion edit data control component';

const EditData = memo(EditDataComponent);

export default EditData;
